<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import Button from '../common/Button.svelte';
  import SmallTitle from '../common/SmallTitle.svelte';
  import Team from '../ui-components/Team.svelte';
  import PageBox from '../ui-components/PageBox.svelte';
  import Common from '../js/common.js';

  if (!Global.pages.includes('teams')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let allTeams = [];
  let allHiddenTeams = [];
  let teams = [];
  let hiddenTeams = [];
  let groups;
  let page;

  let loading = true;
  let error = false;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/teams/get`);

    if (response.ok) {
      const data = await response.json();

      allTeams = data.teams.filter(team => team.slot !== -1);
      allHiddenTeams = data.teams.filter(team => team.slot === -1);
      page = data.page;
      user = data.user;

      groups = Common.unique(allTeams.map(team => JSON.stringify({ value: team.group, slot: team.slot })))
        .map(value => JSON.parse(value));

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');
    } else {
      error = true;
    }

    loading = false;
  })();

  const i18n = {
    pageTitle: {
      cs: `Týmy | ${Global.project.name.cs}`,
      en: `Teams | ${Global.project.name.en}`,
    },
    title: {
      cs: 'Týmy',
      en: 'Teams',
    },
    group: {
      cs: 'Skupina',
      en: 'Group',
    },
    hiddenTeams: {
      cs: 'Skryté týmy',
      en: 'Hidden teams',
    },
    addTeam: {
      cs: 'Přidat tým',
      en: 'Add team',
    },
  };

  $: teams = Common.sortArrayOfObjectsByKey(allTeams, ['slot', `name.${lang}`]);
  $: hiddenTeams = Common.sortArrayOfObjectsByKey(allHiddenTeams, [`name.${lang}`]);

  const projectStyle = Global.project.style;
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='teams' bind:lang bind:user/>

<Title title={i18n.title[lang]} color={projectStyle === 'sharp' ? 'green' : 'blue'} img='title/teams.jpg' bind:lang bind:user/>

<div class='teams'>
  <Loading bind:display={loading}/>
  <Error bind:display={error} bind:lang/>

  {#if !loading && !error}
    <div class='teams-box'>
      {#if user}
        <div class='teams-box-admin'>
          <Button value={i18n.addTeam[lang]} icon='add' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
            onClick={() => { window.location.href = './#/admin/teams/add'; }}/>
        </div>
      {/if}

      {#if groups.map(group => group.value).includes(null)}
        {#each teams as team}
          <div class='teams-box-team'>
            <Team value={team} bind:lang admin={!!user}/>
          </div>
        {/each}
      {:else}
        {#each groups as group}
          <div class='teams-box-group'>
            <div class='teams-box-group-small-title'>
              <SmallTitle value={`${i18n.group[lang]} ${group.value.toUpperCase()}`}/>
            </div>

            <div class='teams-box-group-content'>
              {#each teams.filter(team => team.group === group.value && team.slot === group.slot) as team}
                <div class='teams-box-group-content-team'>
                  <Team value={team} bind:lang admin={!!user}/>
                </div>
              {/each}
            </div>
          </div>
        {/each}
      {/if}

      {#if hiddenTeams.length > 0}
        <div class='teams-box-hidden'>
          <div class='teams-box-hidden-small-title'>
            <SmallTitle value={i18n.hiddenTeams[lang]}/>
          </div>

          <div class='teams-box-hidden-content'>
            {#each hiddenTeams as hiddenTeam}
              <div class='teams-box-hidden-content-team'>
                <Team value={hiddenTeam} bind:lang admin={!!user}/>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>

    <PageBox value={page} page='teams' bind:lang bind:user/>
  {/if}
</div>

<Footer bind:lang/>

<style>
  .teams {
    display: flex;
    flex-direction: column;
    gap: 40px;

    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .teams-box {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
  }

  .teams-box-admin {
    flex-shrink: 0;

    width: 100%;
  }

  .teams-box-team {
    width: calc((100% - 120px) / 4);
  }

  .teams-box-group {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 20px;

    width: calc((100% - 40px) / 2);
  }

  .teams-box-group-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    width: 100%;
  }

  .teams-box-group-content-team {
    flex-grow: 1;

    width: calc((100% - 20px) / 2);
  }

  .teams-box-hidden {
    display: flex;
    flex-direction: column;
    gap: 20px;

    width: 100%;
  }

  .teams-box-hidden-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    width: 100%;
  }

  .teams-box-hidden-content-team {
    flex-grow: 1;

    width: calc((100% - 120px) / 4);
  }

  @media only screen and (max-width: 1200px) {
    .teams-box-team {
      width: calc((100% - 80px) / 3);
    }

    .teams-box-group {
      width: 100%;
    }

    .teams-box-hidden-content-team {
      width: calc((100% - 80px) / 3);
    }
  }

  @media only screen and (max-width: 900px) {
    .teams {
      padding: 40px;
    }

    .teams-box-team {
      width: calc((100% - 40px) / 2);
    }

    .teams-box-hidden-content-team {
      width: calc((100% - 40px) / 2);
    }
  }

  @media only screen and (max-width: 600px) {
    .teams-box-team {
      width: 100%;
    }

    .teams-box-group-content-team {
      width: 100%;
    }

    .teams-box-hidden-content-team {
      width: 100%;
    }
  }

  @media only screen and (max-width: 350px) {
    .teams {
      padding: 40px 20px;
    }
  }
</style>
